module.exports = __webpack_public_path__ + "img/animate-logo-white.09156e8d.svg";